let $closeBtn = $('.js-fancybox-close');
let scrollDuration = 200;
let autoOpenElements = $('.js-fancybox-auto-open');
let disableHashAutoOpenAttr = 'data-hash-autopen';
let isAnimationClass = 'fancy-is-animation';
let containerClass = 'fancybox-container';

disableHashAutoOpen();
setDefaults();
addHandlers();
watchCSS();
afterCloseCorrrectElementStyle();
trackScrollPosition();
autoOpenElementsFunc();
// fixBlinkFixedElements();

function disableHashAutoOpen() {
	
	//пример использования: если был переход на страницу с открытой навигацией (на мобильном), то не открываем её при переходе (клик по кнопке назад)
	
	let $items = $('['+disableHashAutoOpenAttr+']');
	
	$items.each(function() {
		
		let $el = $(this);
		
		if($el.attr(disableHashAutoOpenAttr) === 'false') {
			
			let targetHash = $el.attr('data-hash');
			
			if(targetHash) {
				
				if(window.location.hash.replace('#', '') === targetHash) {
					history.replaceState("", document.title, window.location.pathname + window.location.search);
					history.back();
				}
				
			}
			
		}
		
	});
	
}

function autoOpenElementsFunc() {
	
	setTimeout(function(){
		autoOpenElements.eq(0).trigger('click');
	}, 0)
	
}

// Установка опций по умолчанию
function setDefaults() {
	
	var defaults = $.fancybox.defaults;
	
	defaults.i18n.ru = {
		CLOSE: "Закрыть",
		NEXT: "Следующий",
		PREV: "Предыдущий",
		ERROR: "Запрошенное содержимое не может быть загружено. <br/> Пожалуйста, повторите попытку позже.",
		PLAY_START: "Запуск слайд-шоу",
		PLAY_STOP: "Остановить слайд-шоу",
		FULL_SCREEN: "На весь экран",
		THUMBS: "Галерея",
		DOWNLOAD: "Скачать",
		SHARE: "Поделиться",
		ZOOM: "Приблизить"
	};
	
	defaults.lang = 'ru';
	defaults.touch = false;
	defaults.hash = true; // должно быть true, чтобы при заходе на страницу сразу открывалося нужный попап
	defaults.animationDuration = 300;
	defaults.transitionDuration = 300;
	// defaults.arrows = false;
	// defaults.infobar = false;
	// defaults.animationEffect = 'fade';
	defaults.transitionEffect = 'slide';
	defaults.smallBtn = 'auto';
	defaults.loop = true;
	defaults.backFocus = false;
	// defaults.idleTime = false;
	
	// defaults.btnTpl.arrowLeft = '<button data-fancybox-prev class="fancybox-custom-arrow fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><svg><use xlink:href="'+arrowSvgSrc+'"></use></svg></button>';
	// defaults.btnTpl.arrowRight = '<button data-fancybox-next class="fancybox-custom-arrow fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><svg><use xlink:href="'+arrowSvgSrc+'"></use></svg></button>';
	
	defaults.buttons = [
		// "zoom",
		// "share",
		// "slideShow",
		// "fullScreen",
		// "download",
		// "thumbs",
		"close"
	];
	
	defaults.beforeShow = function (instance, current) {
		
		$('.'+containerClass).addClass(isAnimationClass);
		
		if (current.opts.touch === true) {
			current.opts.touch = {vertical: false};
		}
		
		if (current.type === 'image') {
			current.opts.touch = true;
		}
		
	}
	
	defaults.afterShow = function (instance, current) {
		
		$('.'+containerClass).removeClass(isAnimationClass);
		
		// Удаляем обработчк с события orientationchange (оно срабадывает при адаптивной еерстке и поэтому Fancybox моргает).
		$(window).off("orientationchange.fb");
	}
	
}

function addHandlers() {
	
	// Закрытие fancybox по клику на любой элемент с классом
	$closeBtn.click(function () {
		$.fancybox.close();
	});
	
}

// Возможность закрытия fancybox с помощью css
function watchCSS() {
	
	function runWatchCSS() {
		
		var $fancyContentElement = $('.fancybox-container .fancybox-content');
		
		if ($fancyContentElement.length == 1) {
			
			var afterContent = getComputedStyle($fancyContentElement[0], ':after').content;
			
			if (afterContent.indexOf('fancybox-disable') != -1) {
				$('.fancybox-container').hide();
				$.fancybox.close();
			}
		}
		
	};
	
	window.addEventListener("resize", runWatchCSS);
	
}


// Вернуть первоначальный вид элемента после закрытия попапа (fancybox скрывает элемент и оставляет лишний класс)
function afterCloseCorrrectElementStyle() {
	
	$(document).on('afterClose.fb', function (e, instance, slide) {
		
		var $el = slide.$content;
		
		$el.css('display', '');
		$el.removeClass('fancybox-content');
		
	});
	
}

// Исправление бага мерцания фиксированных элементов в попапе
function fixBlinkFixedElements() {
	
	$(document).on('beforeClose.fb', function (e, instance, slide) {
		
		var $box = slide.$content;
		var $fixedElements = $box.find('*');
		
		var compensate = $box.parent().scrollTop();
		$box.addClass('o-hidden');
		
		$box.scrollTop(compensate);
		
		$fixedElements.each(function () {
			
			var $el = $(this);
			
			if ($el.css('position') === 'fixed') {
				
				if ($el.css('top') === '0px') {
					$el.css('top', compensate + 'px');
				} else if ($el.css('bottom') === '0px') {
					$el.css('bottom', '-' + compensate + 'px');
				}
				
			}
			
		});
		
	});
	
	$(document).on('afterClose.fb', function (e, instance, slide) {
		
		var $box = slide.$content;
		var $fixedElements = $box.find('*');
		
		$box.removeClass('o-hidden');
		
		$fixedElements.each(function () {
			
			var $el = $(this);
			
			if ($el.css('position') === 'fixed') {
				
				$el.css({
					top: '',
					bottom: '',
				});
				
			}
			
		});
		
	});
	
}

function trackScrollPosition() {
	
	$(document).on('beforeClose.fb', function (e, instance, slide) {
		
		if (slide.contentType === 'html') {
			
			var $box = slide.$content;
			var scrollPosition = $box.parent().scrollTop();
			
			$box.data('scrollPosition', scrollPosition);
			
		}
		
	});
	
	
	$(document).on('afterShow.fb', function (e, instance, slide) {
		
		if (slide.contentType === 'html') {
			
			var $box = slide.$content;
			var scrollPosition = $box.data('scrollPosition');
			var $animateElement = $box.parent();
			
			$animateElement.stop().animate({scrollTop: scrollPosition}, scrollDuration);
			
		}
		
	});
	
}